import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '@auth/app/core/services/auth.service';
import { AUTH_ENV } from '@auth/app/core/tokens';
import { SKIP_ERROR_HANDLER_HEADER } from '@common/app/constants/http.constants';
import { ApiError } from '@common/app/models/api-error.model';
import { parseApiError } from '@common/app/utils/api-error.util';

function isSignInRequest(url: string): boolean {
  return url.includes('/auth/tenant/sign-in');
}

export const httpApiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has(SKIP_ERROR_HANDLER_HEADER)) {
    return next(req);
  }

  const auth = inject(AuthService);
  const router = inject(Router);
  const authEnv = inject(AUTH_ENV);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse)) {
        return throwError(() => parseApiError(err));
      }

      const apiError: ApiError = parseApiError(err);

      // 401 = sessão inválida/expirada → login.
      // 403 = autenticado sem permissão → mantém sessão (telas/gates tratam a UX).
      if (apiError.status === 401 && !isSignInRequest(err.url ?? '')) {
        auth.logout();
        void router.navigate([authEnv.loginPath], {
          queryParams: { returnUrl: router.url },
        });
      }

      return throwError(() => apiError);
    }),
  );
};
